// components/Popup.js
import React from 'react';
import './Popup.css'

export default function Popup({ message, onClose }) {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <p>{message}</p>
        <button onClick={onClose} className="btn btn-secondary mt-2">OK</button>
      </div>
    </div>
  );
}
